// extracted by mini-css-extract-plugin
module.exports = {"Confirmation":"Confirmation_Confirmation__VJo8D","title":"Confirmation_title__1tIMY","content":"Confirmation_content__1GAa2","toHome":"Confirmation_toHome__1y-vU"};